/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "../analytics/analytics";

/**
 * This module 'saved-search-signup-prompt' displays the signup
 * overlay when clicking "save search" buttons if you are a logged out user.
 *
 * @constructor
 * @alias module:components/saved-search-signup-prompt
 * @extends module:baustein
 */
export default baustein.register("saved-search-signup-prompt", {
    defaultOptions: {
        searchQuery: null,
        searchGender: null,
        searchNext: null,
        pageType: "signup form",
        pageSubType: "saved_search"
    },

    setupEvents(add) {
        add("click", this.onClick);
    },

    onClick(event) {
        event.preventDefault();

        analytics.event("saved search", "clicked", this.options.searchQuery);

        const queryParams = {
            search_query: this.options.searchQuery,
            search_gender: this.options.searchGender,
            type: "saved_search",
            next: this.options.searchNext
        };

        const options = {
            path: "/account/register/",
            queryParams: queryParams,
            formType: "saved_search",
            pageType: this.options.pageType,
            pageSubType: this.options.pageSubType
        };

        // send it up to the lyst-app to open
        this.emit("triggerSignup", options);
    }
});

